import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DEFAULT_SITE_NAME } from "@/lib/siteIdentity";

export function useSiteSettings() {
    const [settings, setSettings] = useState({ site_name: DEFAULT_SITE_NAME.ar, logo_url: "" });
    useEffect(() => {
        api.get("/public/settings").then((r) => r.data && setSettings((s) => ({ ...s, ...r.data }))).catch(() => {});
    }, []);
    return settings;
}
